import { Injectable } from "@angular/core";
import { HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { ApiService } from "../shared/utilities/api.service";
import { Discussion, DiscussionListConfig } from "../../models";
import { DiscussionListResult } from "../../interfaces";

@Injectable()
export class DiscussionService {
  constructor(private apiService: ApiService) {}

  public findOne(discussionSlug: string): Observable<Discussion> {
    // GET /api/discussions/:discussion
    const getURL = `/discussions/${discussionSlug}`;
    return this.apiService.get(getURL).pipe(map((data) => data.discussion));
  }

  public saveOne(discussion: Discussion): Observable<Discussion> {
    // If we're updating an existing discussion
    // PUT /api/discussions/:community/:discussion
    if (discussion.slug) {
      var putURL = `/discussions/${discussion.community.name}/${discussion.slug}`;

      return this.apiService
        .put(putURL, { discussion: discussion })
        .pipe(map((data) => data.discussion));
    }
    // Otherwise, create a new discussion
    // POST /api/discussions
    else {
      var postURL = `/discussions/${discussion.community}`;

      return this.apiService
        .post(postURL, { discussion: discussion })
        .pipe(map((data) => data.discussion));
    }
  }

  public deleteOne(discussion: Discussion) {
    // DELETE /api/discussions/:community/:discussion
    const communityName = discussion.community.name;
    const discussionSlug = discussion.slug;
    const deleteURL = `/discussions/${communityName}/${discussionSlug}`;

    return this.apiService.delete(deleteURL);
  }

  public findMany(
    config: DiscussionListConfig
  ): Observable<DiscussionListResult> {
    let params = {};

    Object.keys(config.filters).forEach((key) => {
      params[key] = config.filters[key];
    });

    // GET /api/discussions/
    var getURL = `/discussions`;

    // GET /api/discussions/following
    if (config.type === "AllDiscussionsFollowFeed") {
      getURL = "/discussions/following";
    }

    var finalParams = new HttpParams({ fromObject: params });
    return this.apiService.get(getURL, finalParams).pipe(map((data) => data));
  }

  public searchOne(
    config: DiscussionListConfig
  ): Observable<DiscussionListResult> {
    let params = {};

    Object.keys(config.filters).forEach((key) => {
      params[key] = config.filters[key];
    });

    // GET /api/discussions/search/keywords
    const getURL = `/discussions/search/keywords`;

    var finalParams = new HttpParams({ fromObject: params });
    return this.apiService.get(getURL, finalParams).pipe(map((data) => data));
  }
}
